export enum CALL_PAGE {
    LOBBY = "LOBBY",
    ROOM = "ROOM",
    HANG_UP = "HANG_UP",
    ENDED = "ENDED",
}
